import styled from 'styled-components'

export const InventoryWrapper = styled.div`
  position: relative;
  min-height: calc(100vh - 218px);

  table {
    thead {
      tr {
        th {
          padding-bottom: 25px;
        }

        th:first-child {
          padding-left: 40px;
        }
        th:last-child {
          padding-right: 35px;
        }
      }
    }
    tbody {
      tr {
        td:first-child {
          padding-left: 40px;
        }

        td:last-child {
          padding-right: 35px;
        }
      }
    }

    th:last-child {
      text-align: right;
    }

    td .actions-cell {
      justify-content: flex-start;
    }

    td:last-child {
      .actions-cell {
        justify-content: flex-end;

        .link-delete svg {
          margin-right: 0px;
        }

        .power-bank-note {
          margin-left: 12px;
          color: #7e8fa5;
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
  }
`
